export default class Filter {
  nonce;

  constructor() {
    this.nonce = Math.random().toString(36).substring(7);
  }
}
